<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M61.069,169.93C59.21,168.069,56.63,167,54,167s-5.209,1.07-7.07,2.93C45.069,171.79,44,174.37,44,177
			s1.069,5.21,2.93,7.069C48.79,185.93,51.37,187,54,187s5.21-1.07,7.069-2.931C62.93,182.21,64,179.63,64,177
			S62.93,171.79,61.069,169.93z"/>
	</g>
</g>
<g>
	<g>
		<path d="M438,0H235.667c-5.522,0-10,4.478-10,10s4.478,10,10,10H438c5.514,0,10,4.486,10,10v452c0,5.514-4.486,10-10,10H74
			c-5.514,0-10-4.486-10-10V214.333c0-5.522-4.478-10-10-10s-10,4.478-10,10V482c0,16.542,13.458,30,30,30h364
			c16.542,0,30-13.458,30-30V30C468,13.458,454.542,0,438,0z"/>
	</g>
</g>
<g>
	<g>
		<path d="M256,40c-6.804,0-13.642,0.52-20.324,1.544c-5.459,0.838-9.206,5.941-8.369,11.4c0.837,5.459,5.943,9.201,11.4,8.369
			C244.39,60.441,250.208,60,256,60c62.309,0,113.001,50.692,113.001,113.001c0,27.67-10.002,53.043-26.574,72.71
			c-7.333-12.61-17.349-23.487-29.506-31.924c-7.095-4.924-14.718-8.854-22.698-11.763c9.108-8.903,14.777-21.31,14.777-35.022
			v-9.75c0-27.02-21.981-49.001-49-49.001c-27.019,0-49,21.981-49,49.001v9.75c0,13.712,5.668,26.119,14.777,35.022
			c-7.979,2.909-15.602,6.839-22.698,11.763c-12.215,8.478-22.271,19.416-29.613,32.102c-12.627-15.005-21.453-33.461-24.906-54.05
			c-0.913-5.445-6.074-9.119-11.516-8.208c-5.447,0.913-9.122,6.069-8.209,11.516c5.142,30.66,21.059,58.724,44.82,79.021
			c24.031,20.529,54.696,31.835,86.344,31.835c73.337,0,133.001-59.664,133.001-133.001S329.337,40,256,40z M227,157.251
			c0-15.991,13.01-29.001,29-29.001s29,13.01,29,29.001v9.75c0,15.99-13.01,29-29,29s-29-13.01-29-29V157.251z M256,286.002
			c-27.074,0-52.104-9.454-71.694-25.482c13.428-27.252,40.879-44.519,71.694-44.519c30.751,0,58.15,17.196,71.608,44.349
			C308.101,276.371,283.154,286.002,256,286.002z"/>
	</g>
</g>
<g>
	<g>
		<path d="M348.357,398.002h-142c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10h142c5.523,0,10-4.478,10-10
			C358.357,402.48,353.879,398.002,348.357,398.002z"/>
	</g>
</g>
<g>
	<g>
		<path d="M170.71,344.93c-1.86-1.861-4.44-2.93-7.07-2.93s-5.21,1.07-7.07,2.93s-2.93,4.44-2.93,7.07
			c0,2.639,1.071,5.21,2.93,7.069c1.86,1.861,4.44,2.931,7.07,2.931s5.21-1.07,7.07-2.931c1.87-1.859,2.93-4.439,2.93-7.069
			S172.58,346.79,170.71,344.93z"/>
	</g>
</g>
<g>
	<g>
		<path d="M170.71,400.93c-1.86-1.861-4.43-2.93-7.07-2.93c-2.63,0-5.21,1.07-7.07,2.93s-2.93,4.44-2.93,7.07
			c0,2.639,1.071,5.21,2.93,7.069c1.86,1.861,4.44,2.931,7.07,2.931s5.21-1.07,7.07-2.931c1.87-1.859,2.93-4.429,2.93-7.069
			C173.64,405.37,172.58,402.79,170.71,400.93z"/>
	</g>
</g>
<g>
	<g>
		<path d="M348.357,342.002h-142c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10h142c5.523,0,10-4.478,10-10
			C358.357,346.48,353.879,342.002,348.357,342.002z"/>
	</g>
</g>
<g>
	<g>
		<path d="M161.626,57.629c-3.907-3.904-10.237-3.904-14.143,0l-32.566,32.566l-11.129-11.129c-3.907-3.904-10.237-3.904-14.143,0
			c-3.905,3.906-3.905,10.238,0,14.143l18.2,18.2c1.953,1.952,4.511,2.929,7.071,2.929s5.118-0.977,7.072-2.928l39.638-39.638
			C165.531,67.866,165.531,61.534,161.626,57.629z"/>
	</g>
</g>
<g>
	<g>
		<path d="M126,0C80.785,0,44,36.785,44,82c0,45.215,36.785,82,82,82c45.215,0,82-36.785,82-82C208,36.785,171.215,0,126,0z
			 M126,144c-34.187,0-62-27.813-62-62s27.813-62,62-62s62,27.813,62,62S160.187,144,126,144z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
